import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DealerSearchContext } from '@rsc/contexts/DealerSearchContext';
import LinkComponent from '@rsc/ui-components/LinkComponent';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

function BlockBuilderDealerData({ value }) {
  const { tt } = useUiComponentsInternationalContext();

  const { setDealerGateModalActive, storedDealer } =
    useContext(DealerSearchContext);

  let val;

  switch (value?.dealerDataProperty) {
    case 'dealerName':
      val = storedDealer?.name;
      break;

    case 'dealerMainServiceArea':
      val = storedDealer?.mainServiceArea;
      break;

    case 'dealerAreasOfService':
      val = storedDealer?.areasOfService?.[0]?.children?.[0]?.text;
      break;

    case 'dealerPhoneNumber':
      val = storedDealer?.phone;
      break;

    case 'dealerEmail':
      val = storedDealer?.email;
      break;

    case 'triggerDealerSearch':
      val = (
        <LinkComponent
          onClick={() => {
            setDealerGateModalActive(true);
          }}
          style={{ cursor: 'pointer' }}
        >
          {storedDealer
            ? tt(s => s.blockBuilderDealerDataComponent.notYourDealerLink)
            : tt(
                s => s.blockBuilderDealerDataComponent.searchForYourDealerLink
              )}
        </LinkComponent>
      );
      break;

    default:
      break;
  }

  return val;
}

BlockBuilderDealerData.propTypes = {
  value: PropTypes.shape({
    dealerDataProperty: PropTypes.string,
  }).isRequired,
};

export default BlockBuilderDealerData;
